// Description: Component that will display a Header to help the user to locate himself
// Updated: 18/09/2025
// Author: Simon Franklin

// React
import { useLocation } from 'react-router-dom';

// Material UI Components
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Breadcrumbs, { breadcrumbsClasses } from '@mui/material/Breadcrumbs';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';

// Styles for the project
const StyledBreadcrumbs = styled(Breadcrumbs)(({ theme }) => ({
  margin: theme.spacing(1, 0),
  [`& .${breadcrumbsClasses.separator}`]: {
    color: theme.palette.action.disabled,
    margin: 1,
  },
  [`& .${breadcrumbsClasses.ol}`]: {
    alignItems: 'center',
  },
}));

function capitalize(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

// Render The Component
export default function HeaderPage() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);

  return (
    <StyledBreadcrumbs
      aria-label="breadcrumb"
      separator={<NavigateNextRoundedIcon fontSize="small" />}
      sx={{ paddingTop: '12px', marginLeft: '30px' }}
    >
      {pathnames.map((segment, index) => {
        const isLast = index === pathnames.length - 1;
        const decodedSegment = decodeURIComponent(segment);
        return (
          <Typography
            key={index}
            variant="body1"
            sx={{
              color: isLast ? 'text.primary' : 'inherit',
              fontWeight: isLast ? 600 : undefined,
            }}
          >
            {capitalize(decodedSegment)}
          </Typography>
        );
      })}
    </StyledBreadcrumbs>
  );
}
